import { render, staticRenderFns } from "./punishmentCompanyDetail.vue?vue&type=template&id=d5c050b6&scoped=true"
import script from "./punishmentCompanyDetail.vue?vue&type=script&lang=js"
export * from "./punishmentCompanyDetail.vue?vue&type=script&lang=js"
import style0 from "./punishmentCompanyDetail.vue?vue&type=style&index=0&id=d5c050b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5c050b6",
  null
  
)

export default component.exports